/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Authorization_Permission_Read_AlwaysInputs */

const en_agent_authorization_permission_read_always = /** @type {(inputs: Agent_Authorization_Permission_Read_AlwaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Always granted — every other permission depends on it`)
};

const zh_agent_authorization_permission_read_always = /** @type {(inputs: Agent_Authorization_Permission_Read_AlwaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`始终授予——其他权限都依赖它`)
};

/**
* | output |
* | --- |
* | "Always granted — every other permission depends on it" |
*
* @param {Agent_Authorization_Permission_Read_AlwaysInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const agent_authorization_permission_read_always = /** @type {((inputs?: Agent_Authorization_Permission_Read_AlwaysInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Authorization_Permission_Read_AlwaysInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agent_authorization_permission_read_always(inputs)
	return zh_agent_authorization_permission_read_always(inputs)
});
export { agent_authorization_permission_read_always as "agent.authorization.permission.read_always" }